
export function emailIsValid(email) {
    const validEmailRegex = /^\S+@\S+\.\S+$/
    return validEmailRegex.test(email)
}
